module.exports = "pegasus/assets/themelp1/simple/102.png";